export const engagementAppGroupIdCanvasCountryPerformanceWorkflowId =
  "/engagement/:app_group_id/canvas_country_performance/:workflow_id";
